import React, {useEffect, useRef, useState} from 'react';
import "./PlayersMyPicksTab.style.scss";
import {FormattedMessage} from "react-intl";
import {useSelector} from "react-redux";
import {selectUserParlays} from "../../stores/pickX/pickX.selectors";

const PlayersMyPicksTab = ({ onTabClick, viewModes, viewMode }) => {
    const touchStartX = useRef(null);
    const touchEndX = useRef(null);
    const [isFlashing, setIsFlashing] = useState(false);

    const handleTouchStart = (e) => {
        touchStartX.current = e.touches[0].clientX;
        touchEndX.current = null;
    };

    const handleTouchMove = (e) => {
        touchEndX.current = e.touches[0].clientX;
    };

    const handleTouchEnd = () => {
        if (touchStartX.current !== null && touchEndX.current !== null) {
            const diffX = touchStartX.current - touchEndX.current;

            if (Math.abs(diffX) > 50) {
                if (diffX > 0) {
                    if (viewMode === viewModes.MY_PICKS) {
                        onTabClick(viewModes.PLAYERS);
                    }
                } else {
                    if (viewMode === viewModes.PLAYERS) {
                        onTabClick(viewModes.MY_PICKS);
                    }
                }
            }
        }

        touchStartX.current = null;
        touchEndX.current = null;
    };

    const userParlays = useSelector(selectUserParlays);
    const newCreateYourOwnParlay = userParlays.filter(parlay => parlay.Id === "newCreateYourOwn")[0];
    const contestPicks = newCreateYourOwnParlay?.ContestsPicks;
    const contestPicksLength = contestPicks ? Object.entries(contestPicks)?.length : 0;

    useEffect(() => {
        if (contestPicksLength > 0) {
            setIsFlashing(true);
            const timer = setTimeout(() => {
                setIsFlashing(false);
            }, 3000);

            return () => clearTimeout(timer);
        }
    }, [contestPicksLength]);

    return (
        <div
            className="contestTabSelector"
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
        >
            <button
                className={`modeButton ${viewMode === viewModes.PLAYERS ? 'selected gold-background' : ''}`}
                onClick={() => onTabClick(viewModes.PLAYERS)}
            >
                <FormattedMessage id={"lobbyView.contests.customContest.contestTabSelector.players"} />
            </button>
            <button
                className={`modeButton ${viewMode === viewModes.MY_PICKS ? 'selected gold-background' : ''} ${isFlashing ? 'contestPicksCount' : ''}`}
                onClick={() => onTabClick(viewModes.MY_PICKS)}
            >
                <FormattedMessage id={"lobbyView.contests.customContest.contestTabSelector.myPicks"} /> (<span className={`${isFlashing ? 'contestPicksCount' : ''}`}>{contestPicksLength}</span>)
            </button>
        </div>
    );
};

export default PlayersMyPicksTab;
